import React from 'react';
import { BrowserRouter as Router, Route, Link, Switch } from "react-router-dom";
import './styles/style.css';
import buildLink from "./funcs/buildlink";
import Index from './pages/index';
import PremiumLogin from './pages/premium';
import Textos from './pages/textos';
import Videos from './pages/videos';
import Graficos from './pages/graficos';
import Single from './pages/single';
import Creditos from './pages/creditos';
import Footer from './components/footer';
import IndexWithoutInteractivo from './pages/indexwi';
import Menu from './components/menu';

import {ipremium} from './funcs/premium';

export default class App extends React.Component{
  render(){
    var isok = ipremium('2019-11-25 05:30:00');
    return (
      <Router>
          <div id="wrapper">
            <Menu/>
            <div id="binder">
              {
                isok ?
                <Switch>
                  <Route path={buildLink("/videos")} exact component={Videos}  />
                  <Route path={buildLink("/textos")} exact component={Textos}  />
                  <Route path={buildLink("/creditos")} exact component={Creditos}  />
                  <Route path={buildLink("/graficos")} exact component={Graficos}  />
                  <Route path={buildLink("/interactivo")} exact component={Index}  />
                  <Route path={buildLink("/:slug")} component={Single}  />
                  <Route path={buildLink("/")} exact component={Index}  />
                </Switch>
                :
                <Switch>
                  <Route path={buildLink("/")} component={PremiumLogin}  />
                </Switch>
              }

            </div>
            <Footer />
          </div>
        </Router>
    )
  }
}
